import { v4 as uuidv4 } from 'uuid';

class BaseMessage {
  buildRequest(params) {
    this.request = Object.assign({
      jsonrpc: '2.0',
      id: uuidv4()
    }, params);
  }

}

export default BaseMessage;